module.exports = __webpack_public_path__ + "img/InoFiltrar.e3f334d0.svg";